import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BasePanel } from '../Panel/BasePanel';
import { CitationPanelContent } from './CitationPanelContent';
import { TABS } from './constants';
import { CitationProvider } from '../Citation/useCitation/CitationProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartPropertyCitationPanel = ({
  smartPropertyResultId,
  onClose,
  defaultTab = TABS.activity
}) => {
  return /*#__PURE__*/_jsx(BasePanel, {
    inlineSize: "500px",
    isOpen: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(CitationProvider, {
      smartPropertyResultId: smartPropertyResultId,
      children: [/*#__PURE__*/_jsx(BasePanel.Header, {
        children: /*#__PURE__*/_jsx(BasePanel.Heading, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartPropertyCitationPanel.title"
          })
        })
      }), /*#__PURE__*/_jsx(BasePanel.Body, {
        children: /*#__PURE__*/_jsx(BasePanel.Content, {
          paddingBlockStart: "space-sm",
          children: /*#__PURE__*/_jsx(CitationPanelContent, {
            defaultTab: defaultTab
          })
        })
      }), /*#__PURE__*/_jsx(BasePanel.Footer, {
        children: /*#__PURE__*/_jsx(BasePanel.FooterActions, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "smartPropertyCitationPanel.footer.done"
            })
          })
        })
      })]
    })
  });
};